<template>
  <v-app>   

    <v-main>
      <v-container 
            class="fill-height justify-center" 
            fluid
        >
           <v-row 
            class="text-center"
            style="z-index:10"
          >
              <v-col cols="12">
                <v-img
                  :src="require('./assets/logo.png')"
                  class="my-3"
                  contain
                  height="250"
                />
              </v-col>

              <v-col cols="12" class="mb-4">
                <h1 class="primary--text display-2 font-weight-bold mb-3">
                  Welcome to {{ schoolName }}
                </h1>

                <p class="display-1 font-weight-light primary--text">
                  Student and Teacher Online Portal
                </p>  
              </v-col>

              <v-col cols="12">
                <h2 class="primary--text font-weight-light font-italic">
                  Select the link to get started
                </h2>
              </v-col>

              <v-row class="d-flex justify-center">

                <v-col
                  cols="12"
                  md="3"
                  
                  
                >
                    <v-btn
                      color="primary mr-3"
                      dark
                      large
                      href="https://student-portal.bishopansteyhigh.net"    
                      target="_blank"
                      width="240"
                    >Student Portal</v-btn>
                </v-col>  
                <v-col
                  cols="12"
                  md="3"
                >
                    <v-btn
                      color="primary"                    
                      outlined
                      large
                      href="https://term-reports.bishopansteyhigh.net" 
                      target="_blank"
                      width="240"
                    >Teacher Portal</v-btn>
                </v-col>  
                <v-col
                  cols="12"
                  md="3"
                >
                    <v-btn
                      color="secondary"
                      dark
                      large
                      href="https://term-reports.bishopansteyhigh.net/admin"  
                      target="_blank"
                      width="240"                   
                    >
                      <span class="black--text">Admin Portal</span>
                    </v-btn>
                </v-col>  
                <!-- <v-col
                  cols="12"
                  md="2"
                >
                    <v-btn
                      color="secondary"
                      outlined
                      dark
                      large
                      href="https://sixth-form-application.bishopansteyhigh.net/"                     
                      target="_blank"
                      width="240"
                    >
                      <span class="black--text">6th Form Applications</span>
                    </v-btn>
                </v-col>   -->
              </v-row>
           </v-row>
        </v-container>
      
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
    
  },

  data: () => ({
    schoolName: "Bishop Anstey High School",
  }),
};
</script>
 
